/**
 * Table Persistence Keys
 *
 * This file contains the keys used for persisting table states in localStorage.
 * These keys are used by vuex-persistedstate to save and restore table configurations
 * such as column visibility, sorting, and filtering preferences.
 *
 * IMPORTANT: Changing any of these keys will:
 * 1. Clear the existing persisted state for that table
 * 2. Reset all user preferences for that table
 *
 * Versioning Strategy:
 * - Increment the version number (e.g., command-center-13 -> command-center-14) when:
 *   - Adding/removing columns
 *   - Changing column structure
 *   - Modifying default settings
 *   - Making breaking changes to the table configuration
 */

export const LEARNERS_TABLE_KEY = 'command-center-14';

// Last update: changed to acomodate new columns and new all classes endpoint from live-instruction
export const MY_SCHEDULE_TABLE_KEY = 'my-schedule-2';

// Last update: changed to acomodate new all classes endpoint from live-instruction
export const ALL_CLASSES_TABLE_KEY = 'teacher-admin-10';

export const LESSONS_TABLE_KEY = 'lessons-9';

export const SHARE_HISTORY_TABLE_KEY = 'share-history-1';
